import { Outlet } from "react-router-dom";
import Header from "./Header/Header";
import Navbar from "./Navbar/Navbar";
import NavMenu from "./Menu/Menu";

function AppLayout() {
  return (
    <>
      <Header />
      <NavMenu/>
      <Outlet />
    </>
  );
}

export default AppLayout;
